import { Button, Col, Row, Space, Table, Tag, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import "./memberTable.css";
import ResetPassword from "../resetPassword/resetPassword";
import EditorMember from "../editorMember/editorMember";
import DeleteModal from "../deleteModal/deleteModal";
import { forwardRef } from "react";
import { useState } from "react";
import { useImperativeHandle } from "react";
import moment from "moment/moment";

const MemberTable = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const { setIsFresh } = props;
  const columns = [
    {
      title: "成员编号",
      dataIndex: "id",
      key: "id",
      width: 100,
    },
    {
      title: "昵称",
      dataIndex: "nickname",
      key: "nickname",
      width: 150,
    },
    {
      title: "用户名",
      dataIndex: "username",
      key: "username",
      width: 150,
    },
    {
      title: "角色",
      key: "role",
      dataIndex: "role",
      // width: 130,
      ellipsis: {
        showTitle: false,
      },
      render: (role) => (
        <Tooltip placement="topLeft" title={role}>
          {role}
        </Tooltip>
      ),
    },
    {
      title: "注册时间",
      key: "createdAt",
      dataIndex: "createdAt",
    },

    {
      title: "操作",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <EditorMember info={record} setIsFresh={setIsFresh} />
          <DeleteModal info={record} setIsFresh={setIsFresh} />
          <ResetPassword info={record} />
        </Space>
      ),
    },
  ];

  const switchRole = (num) => {
    const res = [];
    num.map((item, index) => {
      switch (item) {
        case 1:
          res.push("超级管理员");
          break;
        case 2:
          res.push("管理员");
          break;
        case 3:
          res.push("审核员");
          break;
        case 4:
          res.push("房源管理员");
          break;
        case 5:
          res.push("内容管理员");
          break;
        case 6:
          res.push("活动管理员");
          break;
        default:
          break;
      }
    });
    const finalres = res.join("、");
    // console.log(finalres);
    return finalres;
  };
  const changeData = (data) => {
    data.map((info, index) => {
      info.key = index;
      info.role = switchRole(info.authority);
      // const date = new Date(info.created_at)
      info.createdAt = moment(info.created_at).format("YYYY-MM-DD HH:mm:ss");
      // info.createdAt = new Date(info.created_at)
      // console.log(info.created_at,info.createdAt)
      return info;
    });

    setData(data);
  };

  useImperativeHandle(ref, () => ({
    changeData,
  }));

  return (
    <div
      className="memberTable"
      style={{ backgroundColor: "white", padding: "30px" }}
    >
      {/* <Row>
        <Col flex={4}></Col>
        <Col flex={1}>

        </Col>
      </Row> */}
      <Table columns={columns} dataSource={data} pagination={false} />
    </div>
  );
});

export default MemberTable;
